import { HttpContextToken } from '@angular/common/http';

export const IDEMPOTENCY_DISABLED = new HttpContextToken<boolean>(() => false);
export const IDEMPOTENCY_KEY = new HttpContextToken<string | null>(() => null);
